import { insertFromTemplate } from "../editor/insertFromTemplate";
import { newId } from "../id/id";
import {
  AircraftAddonTemplate,
  BlankTemplate,
  SoftwareAddonTemplate,
  isAircraftAddonTemplate,
} from "../model/addonTemplate";
import {
  Checklist,
  ChecklistHeader,
  ChecklistItem,
  ChecklistRole,
} from "../model/checklistAppState";
import { ChecklistDocument } from "../model/editorState";
import { newChecklistDocument } from "../state/checklist";
import { deserializeAircraftTemplate } from "../state/convert";

export function newChecklist(title = "", role: ChecklistRole | undefined = undefined): Checklist {
  const generated: Checklist = {
    id: newId(),
    type: "checklist",
    title: { id: newId(), content: title, editing: "external" },
    content: [],
    role: role !== undefined ? [role] : [],
  };

  return generated;
}

export function newChecklistItem(): ChecklistItem {
  const newItem: ChecklistItem = {
    id: newId(),
    type: "item",
    item: { content: "", editing: "external", id: newId() },
    setting: {
      content: "",
      editing: "external",
      id: newId(),
    },
  };

  return newItem;
}

export function newChecklistHeader(): ChecklistHeader {
  const newHeader: ChecklistHeader = {
    id: newId(),
    type: "header",
    text: { content: "", editing: "external", id: newId() },
  };

  return newHeader;
}

export function newChecklistDocumentFromTemplates(
  title: string,
  baseTemplate: AircraftAddonTemplate | BlankTemplate,
  softwareAddons: SoftwareAddonTemplate[]
): ChecklistDocument {
  const deserializedBaseContents = isAircraftAddonTemplate(baseTemplate)
    ? deserializeAircraftTemplate(baseTemplate.content)
    : [];

  const document: ChecklistDocument = newChecklistDocument();
  document.title = title;
  document.contents.title.content = isAircraftAddonTemplate(baseTemplate) ? baseTemplate.title : "";
  document.contents.checklists = [...deserializedBaseContents];

  softwareAddons.forEach((softwareAddon) => {
    insertFromTemplate(document, softwareAddon);
  });

  return document;
}
